import mod from "-!./U3Queue.js?vue&type=script&lang=js&"; export default mod; export * from "-!./U3Queue.js?vue&type=script&lang=js&"